export default __webpack_public_path__ + "static/sml-05b6addeb29feb78d0799cce64b0783a.jpeg";